import { createContext, useContext } from 'react';

/**
 * Identidade do manual aberto. Só existe para os componentes de imagem lá no
 * fundo do formulário saberem para onde subir o arquivo — sem isso a foto
 * voltaria a virar base64 dentro do documento.
 */
export const ContextoManual = createContext<{ manualId: string | null }>({ manualId: null });

export function useManualAtual() {
  return useContext(ContextoManual);
}
